import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { fetchRemittanceInstructionURL } from '../api/remittance-instructions.ts';

export default function useDownloadRemittanceInstructionReport(): UseMutationResult<
  string,
  Error,
  string
> {
  return useMutation({
    mutationFn: (id) => fetchRemittanceInstructionURL(id),
    onSuccess: (url) => {
      // 透過動態建立 <a> 標籤來下載
      const link = document.createElement('a');
      link.href = url;
      link.download = ''; // 不設定時，會使用伺服器回傳的檔名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  });
}
